import { isValid, min, parseISO } from 'date-fns';
import { isEmpty } from 'ramda';

import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors.js';
import { accountIdSelector } from 'store/user/selectors';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';
import { getDefaultFormatDate } from 'utils/date';
import { decamelizeKeys } from 'utils/humps';

import { transformBEScheduleToFEForm } from './transform';

import { createScheduleItem, initializeScheduleAction } from '.';

const decoratedAxiosGet = axiosGetAutoCancelDecorator();
export const searchPagesThunk = (queryParams) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());
  const response = await decoratedAxiosGet(`/acc/${accountId}/pages/dropdown`, { params: decamelizeKeys(queryParams) });

  return (
    response.data.data?.map((item) => ({
      name: item.name,
      handle: item.handle,
      tags: item.tags.length > 0 ? `Tags: ${item?.tags.slice(0, 3).join(', ')}` : '',
      id: item.id,
      isSafariPortalContent: item.systemWide,
      shared: item?.shared,
      currentStep: item.currentStep,
      type: item.type,
    })) ?? []
  );
};

export const initializeSheduleThunk =
  ({ createItemIfEmpty = false } = {}) =>
  (dispatch, getStore) => {
    const itineraryData = itinerariesItemDataSelector(getStore());

    const minScheduledStartDate = min(itineraryData.schedules.map((item) => parseISO(item.datesRange.start)));
    // Required because saving with the type OrganizeBy.Day erases travelStartDate on the backend
    const safeTravelStartDate = (() => {
      if (itineraryData.travelStartDate) return itineraryData.travelStartDate;
      if (isValid(minScheduledStartDate)) return getDefaultFormatDate(minScheduledStartDate);
      return null;
    })();

    dispatch(
      initializeScheduleAction({
        schedule: transformBEScheduleToFEForm({
          travelStartDate: safeTravelStartDate,
          type: itineraryData.scheduleType,
          items:
            createItemIfEmpty && isEmpty(itineraryData.schedules) ? [createScheduleItem()] : itineraryData.schedules,
        }),
      }),
    );
  };
